import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useMemo, useCallback } from "react";
import classnames from "classnames";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/PaymentSelect.module.scss";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import PaymentRadioButton from "./PaymentRadioButton";
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import { useAdultModeQuery } from "@/hooks";
import { PURCHASE_MODE, IGNORE_PAYPAY } from "./index";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PaymentMethodsList(_ref) {
  var mode = _ref.mode,
      paymentMethods = _ref.paymentMethods,
      paymentInstruments = _ref.paymentInstruments,
      register = _ref.register,
      onChange = _ref.onChange;
  if (!paymentMethods) return null;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      data = _useAdultModeQuery.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  var purchase = PURCHASE_MODE.includes(mode); // 登録済みの支払い方法

  var registeredPaymentMethodIds = useMemo(function () {
    if (!paymentInstruments) return [];
    return paymentInstruments.map(function (payment) {
      return payment.payment_method_id;
    });
  }, [paymentInstruments]); // 支払い方法ごとに分ける

  var creditCard = useMemo(function () {
    return paymentMethods.filter(function (v) {
      return v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD;
    });
  }, [paymentMethods]);
  var paypay = useMemo(function () {
    return paymentMethods.filter(function (v) {
      return !IGNORE_PAYPAY.includes(mode) && !registeredPaymentMethodIds.includes(v.payment_method_id) && v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY;
    });
  }, [mode, paymentMethods, registeredPaymentMethodIds]);
  var carrier = useMemo(function () {
    return paymentMethods.filter(function (v) {
      return !registeredPaymentMethodIds.includes(v.payment_method_id) && [PAYMENT_METHOD_ID.AU, PAYMENT_METHOD_ID.DOCOMO, PAYMENT_METHOD_ID.SOFTBANK].includes(v.payment_method_id);
    });
  }, [paymentMethods, registeredPaymentMethodIds]);
  var labelClassName = useCallback(function (v) {
    var _classnames;

    return classnames(styles.radioCheck, styles.paymentMethodIcon, (_classnames = {}, _defineProperty(_classnames, styles.creditCard, v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD), _defineProperty(_classnames, styles.paypay, v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY), _defineProperty(_classnames, styles.docomo, v.payment_method_id === PAYMENT_METHOD_ID.DOCOMO), _defineProperty(_classnames, styles.softbank, v.payment_method_id === PAYMENT_METHOD_ID.SOFTBANK), _defineProperty(_classnames, styles.au, v.payment_method_id == PAYMENT_METHOD_ID.AU), _classnames));
  }, []);
  var handleChange = useCallback(function (e) {
    var paymentMethodId = Number(e.target.value);
    onChange({
      paymentMethod: paymentMethodId,
      createPayment: true,
      showInput: paymentMethodId === PAYMENT_METHOD_ID.CREDIT_CARD
    });
  }, []);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: "".concat(formStyles.marginOff, " ").concat(styles.paymentMethodsListFieldset),
    children: [/*#__PURE__*/_jsxs("p", {
      className: styles.paymentInstrumentsListFieldsetTitle,
      children: [purchase && "その他のお支払い方法を利用する", !purchase && "新しく追加するお支払い方法"]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.paymentInstrumentStyle,
      children: [creditCard && /*#__PURE__*/_jsx(_Fragment, {
        children: creditCard.map(function (v) {
          return /*#__PURE__*/_jsx(PaymentRadioButton, {
            ref: register,
            paymentMethodId: v.payment_method_id,
            id: "paymentMethodId".concat(v.payment_method_id),
            className: labelClassName(v),
            value: v.payment_method_id,
            onChange: handleChange,
            children: /*#__PURE__*/_jsxs("div", {
              className: styles.iconWithText,
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.cardImage,
                children: /*#__PURE__*/_jsx(PaymentIconImage, {
                  large: true,
                  paymentMethodId: PAYMENT_METHOD_ID.CREDIT_CARD,
                  cardType: "all"
                })
              }), /*#__PURE__*/_jsx("span", {
                className: styles.paymentCreditCardText,
                children: "\u5404\u7A2E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9"
              })]
            })
          }, "paymentMethod-".concat(v.payment_method_id));
        })
      }), paypay && /*#__PURE__*/_jsx(_Fragment, {
        children: paypay.map(function (v) {
          return /*#__PURE__*/_jsx(PaymentRadioButton, {
            ref: register,
            paymentMethodId: v.payment_method_id,
            id: "paymentMethodId".concat(v.payment_method_id),
            className: labelClassName(v),
            value: v.payment_method_id,
            onChange: handleChange,
            disabled: adultMode,
            children: /*#__PURE__*/_jsx(PaymentIconImage, {
              large: true,
              paymentMethodId: v.payment_method_id
            })
          }, "paymentMethod-".concat(v.payment_method_id));
        })
      }), carrier && /*#__PURE__*/_jsx("div", {
        className: styles.carrierPayments,
        children: carrier.map(function (v) {
          return /*#__PURE__*/_jsx(PaymentRadioButton, {
            ref: register,
            paymentMethodId: v.payment_method_id,
            id: "paymentMethodId".concat(v.payment_method_id),
            className: labelClassName(v),
            value: v.payment_method_id,
            onChange: handleChange,
            disabled: adultMode,
            children: /*#__PURE__*/_jsx(PaymentIconImage, {
              large: true,
              paymentMethodId: v.payment_method_id
            })
          }, "paymentMethod-".concat(v.payment_method_id));
        })
      }), purchase && !adultMode && /*#__PURE__*/_jsx("p", {
        className: styles.caution,
        children: "\u30AD\u30E3\u30EA\u30A2\u6C7A\u6E08\u3092\u65B0\u898F\u3067\u3054\u767B\u9332\u3044\u305F\u3060\u304F\u969B\u3001\u5404\u30AD\u30E3\u30EA\u30A2\u306E\u30DA\u30FC\u30B8\u3067\u304A\u624B\u7D9A\u304D\u5F8C\u306B\u5546\u54C1\u8CFC\u5165\u78BA\u8A8D\u753B\u9762\u306B\u623B\u3063\u3066\u304F\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u3001\u624B\u7D9A\u3092\u4E2D\u65AD\u3055\u308C\u306C\u3088\u3046\u304A\u6C17\u3092\u3064\u3051\u304F\u3060\u3055\u3044\u3002"
      }), IGNORE_PAYPAY.includes(mode) && /*#__PURE__*/_jsx("span", {
        className: formStyles.caption,
        children: "\u65B0\u898F\u6C7A\u6E08\u6642\u306EPayPay\u3067\u306E\u304A\u652F\u6255\u3044\u3092\u73FE\u5728\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093"
      })]
    })]
  });
}